import React, { useEffect, useState } from 'react';
import holdingHand from '../../Assets/holdinghand.png';
import emailImage from '../../Assets/email.png';
import linkedIf from '../../Assets/linkedin.png';
// import behance from '../../Assets/behance.png';
// import dribble from '../../Assets/dribble.png';
import insta from '../../Assets/insta.png';
import copyright from '../../Assets/copyright.png';
import hand from '../../Assets/hand.png';
import { useLocation } from 'react-router-dom';

const HomeFooter = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const location = useLocation();
    
    const isMobile = windowWidth <= 767;
    const isTablet = windowWidth > 767 && windowWidth <= 1023;

    const getLocation = () => {
        if (location && location?.pathname && location?.pathname.includes("/project/")) {
            return "project"
        } else return "";
    }

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleCopy = () => {
        navigator?.clipboard?.writeText("leinasingha08@gmail.com");
    }

    // Email button styles based on screen size
    const getEmailButtonClass = () => {
        if (isMobile) {
            return 'h3_fOE h3_fOE_mobile';
        } else if (isTablet) {
            return 'h3_fOE h3_fOE_tablet';
        } else {
            return 'h3_fOE';
        }
    };

    // Email text styles based on screen size
    const getEmailTextClass = () => {
        if (isMobile) {
            return 'h3_fOET font-satoshi text-lg';
        } else if (isTablet) {
            return 'h3_fOET font-satoshi text-2xl';
        } else {
            return 'h3_fOET font-satoshi';
        }
    };

    return (
        getLocation() === "" 
        ?
            <div className='homeFooterContainer'>
                <div className='h3_footerOne'>
                    <div className='h3_fOT font-satoshi'>
                        Let's Get in touch
                        <img 
                            src={holdingHand} 
                            alt="holdinghand" 
                            className={isMobile ? 'w-6 ml-2' : isTablet ? 'w-8 ml-2' : ''}
                        />
                    </div>
                    <div className={getEmailButtonClass()} onClick={handleCopy}>
                        <img 
                            src={emailImage} 
                            alt="email" 
                            className={isMobile ? 'w-6' : isTablet ? 'w-8' : ''}
                        />
                        <div className={getEmailTextClass()}>
                            {isMobile ? 'leinasingha08@...' : 'leinasingha08@gmail.com'}
                        </div>
                        <div className={`h3_fOE_RT ${isMobile ? 'text-xs' : isTablet ? 'text-sm' : ''}`}>
                            TAP TO COPY
                        </div>
                    </div>
                    <div className='hFBHI'>
                        <img 
                            src={hand} 
                            alt="hand" 
                        />
                    </div>
                    <div className='h3_fOB'>
                        <div className='flex space-x-4'>
                            <a href="https://www.linkedin.com/in/leinasingha026" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src={linkedIf} 
                                    alt='linkedIn' 
                                    className={isMobile ? 'w-6' : isTablet ? 'w-7' : ''}
                                />
                            </a>
                            {/* <img 
                                src={behance} 
                                alt='behance' 
                                className={isMobile ? 'w-6' : isTablet ? 'w-7' : ''}
                            /> */}
                            {/* <img 
                                src={dribble} 
                                alt='dribble' 
                                className={isMobile ? 'w-6' : isTablet ? 'w-7' : ''}
                            /> */}
                            <a href='https://www.instagram.com/leina_n/' target="_blank" rel="noopener noreferrer">
                                <img 
                                    src={insta} 
                                    alt='insta' 
                                    className={isMobile ? 'w-6' : isTablet ? 'w-7' : ''}
                                />
                            </a>
                        </div>
                        <div className='flex items-center'>
                            <img 
                                src={copyright} 
                                alt="copyright" 
                                className={isMobile ? 'w-4' : isTablet ? 'w-5' : ''}
                            />
                            <div className={`h3_fOBT ml-2 font-satoshi ${isMobile ? 'text-sm' : isTablet ? 'text-base' : ''}`}>
                                Leina 2024
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        :
            <div></div>
    )
};

export default HomeFooter;
